import type { AwsMidcComponents } from "@p0security/integrations-aws-midc-shared/components";
import { midcInstallCommands } from "@p0security/integrations-aws-midc-shared/policy";
import type { FrontendInstaller } from "@p0security/integrations-installer";
import { Typography } from "@p0security/ui";

export const awsMidcInstaller: FrontendInstaller<typeof AwsMidcComponents> = {
  components: {
    identity: {
      instructions: (context, id, item) => {
        const serviceAccountId = item.serviceAccountId;
        return {
          help: (
            <>
              To install P0 Identity Center access, provision P0&apos;s access
              using{" "}
              <Typography.Link
                href={`https://${id}.signin.aws.amazon.com/console`}
                target="_blank"
                rel="noopener"
              >
                AWS Cloud Shell
              </Typography.Link>
              :
            </>
          ),
          commands: {
            shell: [
              {
                command: midcInstallCommands(context, {
                  gcloudServiceAccountId: serviceAccountId,
                  awsAccountId: id,
                }),
              },
            ],
          },
        };
      },
      items: {},
    },
  },
};
